import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import SwipeableTextMobileStepper from "./MobileStepper";
import { SecondaryStyle } from "../fonts";

import LB1 from "assets/Page1LB1.webp";
import LB2 from "assets/Page1LB2.webp";
import LB3 from "assets/Page1LB2.webp";
import RB from "../assets/Page1RB.webp";
import RDT from "../assets/Page1RDT.webp";
import RDB from "../assets/Page1RDB.webp";
//@ts-ignore
import RA from "../assets/Page1RA.mp4";
//@ts-ignore
import LD from "../assets/Page1LD.mp4";

const carousel1Images = [LB1, LB2, LB3];

const Page1 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* First Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{
                height: "100%",
                borderTop: { xs: "1vh solid #fff", sm: "none" },
              }}
            >
              {/* LA/LD */}
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: "100%",
                    width: "100%",
                    maxHeight: { xs: "100%", sm: "50vh" },
                  }}
                >
                  {/* LC */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      maxHeight: "50vh",
                      borderBottom: ".5vh solid #fff",

                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: {
                          xs: "45vh",
                          sm: "100%",
                        },
                        maxHeight: "50vh",

                        objectFit: "cover",
                      }}
                      src={LD}
                      playsInline
                      autoPlay
                      muted
                      loop
                    />
                  </Grid>

                  {/* LB */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      px: { xs: 1.5, md: 1.5, lg: 2, xl: 3 },
                      pb: { xs: 1.5 },
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        ...SecondaryStyle,

                        textAlign: { xs: "justify", sm: "left" },
                        "@media (orientation: landscape)": {
                          fontSize: { xs: "1vw", md: "1vw", lg: "0.95vw" },
                          lineHeight: {
                            xs: "1.5vw",
                            md: "1.5vw",
                            lg: "1.5vw",
                          },
                        },
                        "@media (orientation: portrait)": {
                          fontSize: { xs: "1.7vh", sm: "1vh" },
                          lineHeight: {
                            xs: "2vh",
                            sm: "1.5vh",
                            md: "1.5vh",
                            lg: "1.5vh",
                          },
                          paddingTop: {
                            xs: "1vh",
                            sm: "2vh",
                            md: "2vh",
                            lg: "2vh",
                          },
                        },
                      }}
                    >
                      Step into this beautifully renovated home, where modern
                      luxury meets cozy comfort. The charming entrance leads you
                      into an inviting living area, bathed in natural light from
                      large windows, highlighting the vibrant colours,
                      thoughtful design, and rich maple hardwood floors
                      throughout. The dining area seamlessly connects to the
                      living room, offering a perfect space for both relaxation
                      and entertaining. With its carefully considered details,
                      this home is perfectly suited for modern living in the
                      vibrant Wychwood neighbourhood.
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              {/** */}
              <Grid item xs={12} sm={6}>
                <Grid container direction={"row"} sx={{ height: "100%" }}>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      height: { xs: "36vh", sm: "100%" },
                      maxHeight: "50vh",
                      borderBottom: { xs: ".5vh solid #fff", sm: "none" },
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },

                      borderRadius: { xs: "16px", sm: "0vh" },
                    }}
                  >
                    <SwipeableTextMobileStepper images={carousel1Images} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: "100%",
                  }}
                >
                  {/* RD/RA */}
                  <Grid
                    container
                    direction={"row"}
                    sx={{
                      height: "100%",
                    }}
                  >
                    {/* RD */} {/* RA */}
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      sx={{
                        borderTop: {
                          xs: ".5vh solid #fff",
                          sm: "none",
                        },
                        borderBottom: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderRight: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderLeft: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fff",
                        },

                        height: {
                          xs: "93.8vh",
                          sm: "100%",
                        },
                        maxHeight: { xs: "100%", sm: "50vh" },
                      }}
                    >
                      <Box
                        sx={{
                          height: { xs: "46vh", sm: "24.1vh" },
                          borderRadius: { xs: "16px", sm: "0vh" },

                          borderBottom: {
                            xs: ".5vh solid #fff",
                            sm: ".5vh solid #fff",
                          },
                          backgroundImage: `url('${RDT}')`,
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      />

                      <Box
                        sx={{
                          height: { xs: "46vh", sm: "24.5vh" },

                          borderRadius: { xs: "16px", sm: "0vh" },
                          borderTop: ".5vh solid #fff",
                          backgroundImage: `url('${RDB}')`,
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      sx={{
                        maxHeight: "50vh",
                        borderTop: {
                          xs: ".5vh solid #fff",
                          sm: "none",
                        },
                        borderRight: {
                          xs: "1vh solid #fff",
                          sm: "none",
                        },
                        borderLeft: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderBottom: ".5vh solid #fff",
                      }}
                    >
                      <CardMedia
                        component={"video"}
                        sx={{
                          borderRadius: { xs: "16px", sm: "0vh" },
                          height: {
                            xs: "45vh",
                            sm: "100%",
                          },
                          maxHeight: "50vh",

                          objectFit: "cover",
                        }}
                        src={RA}
                        playsInline
                        autoPlay
                        muted
                        loop
                      />
                    </Grid>
                    {/**RC */}
                    <Grid
                      item
                      xs={12}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderTop: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderLeft: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fffe",
                        },
                        borderBottom: { xs: "1vh solid #fff", sm: "none" },
                        borderRight: {
                          xs: "1vh solid #fff",
                          sm: "none",
                        },
                        height: {
                          xs: "45.5vh",
                          sm: "50vh",
                        },
                        backgroundImage: `url('${RB}')`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page1;
